module.exports = __webpack_public_path__ + "img/active-layer2.60872516.png";